declare const __RUNTIME_CONFIG__: Record<string, string>;

export function getConfigValue(key: string): string {
  const fullKey = `NX_${key}`;

  // Use the injected runtime config (works with both bundlers)
  if (typeof __RUNTIME_CONFIG__ !== 'undefined') {
    return __RUNTIME_CONFIG__[fullKey] || '';
  }

  // Fallback for development/SSR
  if (typeof process !== 'undefined' && process.env) {
    return process.env[fullKey] || '';
  }

  // Vite fallback
  if (typeof import.meta !== 'undefined' && (import.meta as any).env) {
    return (import.meta as any).env[fullKey] || '';
  }

  return '';
}
